<template>
    <div style="background-color: white;">
        <div class="card"
            style="padding: 24px; border-top-left-radius: 0 !important; border-top-right-radius: 0; border-radius: 10px">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
                Acceptance Letter
            </div>

            <div class="row">
                <div class="col-md-6">
                    <TextInput label="Our Ref" :modelValue="data.claim_intimation_number" :readonly="true" />
                    <TextInput label="Name of Covered person" :modelValue="personCovered" :readonly="true" />
                </div>
                <div class="col-md-6">
                    <TextInput label="Letter Date" type="date" :modelValue="formattedDate" :readonly="true" />
                    <TextInput label="Amount in B$" :modelValue="amount" type="number" required
                        :errorMessage="errorMessage" :onChange="handleAmountChange"
                        :readonly="payments && payments.submitted === 1" />
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                    <div class="d-flex w-100 align-items-center">
                        <div class="w-50">
                            <p class="mb-0 text-end pe-2" style="font-weight: 800;">Total Claim Settlement:</p>
                        </div>
                        <div class="w-100 border text-center" style="padding: 8px;">
                            B$ {{ amount }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end" style="margin-top: 24px ;">
            <button class="btn btn-lg btn-outline-primary col-2" style="margin-right: 10px;"
                v-if="!payments || (payments.submitted !== 1)" @click="handleStorePayment(0)">
                Save as Draft
            </button>
            <button class="btn btn-lg btn-primary col-2" style="margin-right: 10px;" @click="handleStorePayment(1)"
                v-if="!payments || (payments.submitted !== 1)">
                Submit
            </button>
            <button class="btn btn-lg btn-dark col-2" :disabled="!payments" @click="handlePreview">
                Preview
            </button>
        </div>
    </div>

</template>

<script>
import TextInput from '../../../components/TextInput.vue';
import moment from 'moment'
import { getPayment, storePayment } from '../../../services/ClaimService';
import { global } from '../../../global';
import { getRequest } from '../../../services/RequestService';

export default {
    name: "ApprovedPage",
    components: {
        TextInput,
    },
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            amount: 0,
            errorMessage: '',
            payments: null,
        };
    },

    computed: {
        formattedDate() {
            return moment(this.data.approved_at).format('YYYY-MM-DD');
        },
        personCovered() {
            const found = this.data.claims_meta.find(item => item.meta_key === "person_covered");
            return found ? found.meta_value : '';
        }
    },

    methods: {
        async fetchPayment() {
            try {
                const response = await getPayment(this.data.id);
                if (response.data.success) {
                    this.payments = response.data.data;
                    this.amount = this.payments.amount
                } else {
                    console.error(response.data.message);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async handleStorePayment(submitted) {
            if (this.amount <= 0) {
                this.errorMessage = 'Amount must be greater than 0';
                return;
            }

            const request = {
                claim_id: this.data.id,
                amount: this.amount,
                reference_no: this.data.claim_intimation_number,
                letter_date: moment(this.data.approved_at).format('YYYY-MM-DD'),
                submitted: submitted || 0,
            }

            try {
                const response = await storePayment(request)
                if (response.data.success) {
                    swal({
                        icon: "success",
                        text: response.data.message
                    })
                        .then(ok => {
                            if (submitted === 1) {
                                this.$router.push({ name: "tba_claim" });
                            }
                        });

                    this.fetchPayment();

                } else {
                    swal({
                        icon: "error",
                        text: response.data.message
                    })
                }
            } catch (error) {
                swal({
                    icon: "error",
                    text: error.response.data.message
                })
            }
        },


        async handlePreview() {
            try {
                // 1. Fetch PDF as blob
                const response = await getRequest(this.payments.file_url, { responseType: 'blob' });

                if (response.status !== 200) throw new Error('Failed to fetch PDF');

                const blob = response.data;

                // 2. Create temporary URL
                const url = window.URL.createObjectURL(blob);

                // 3. Download
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'approve_letter.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();

                // 4. Preview in new tab
                window.open(url, '_blank');

            } catch (err) {
                console.error(err);
                alert('Preview failed');
            }
        },

        handleAmountChange(e) {
            const value = e.target.value;
            this.amount = value;
            this.errorMessage = '';
        }
    },

    mounted() {
        this.fetchPayment();
    },
};
</script>
